(function() {
    window.addEventListener('DOMContentLoaded', function() {

        // Mobile menu
        $('.nav').on('click', '.off-canvas__toggle-button', function(e) {
            e.preventDefault();
            var $el = $(this);
            var direction = $el.parents('.off-canvas__container').data('off-canvas-direction');
            $('.off-canvas').toggleClass('off-canvas--' + direction);
        });

        $('.nav__item__title').click( function(e) {
            let target = e.target,
                isWhatsNew = target.textContent.trim().toUpperCase() === "WHAT'S NEW",
                homepage = document.getElementById('main'),
                mobile = false,
                w = window, 
                a = 'inner';

            if (!('innerWidth' in window )) {
                    a = 'client';
                    w = document.documentElement || document.body;
            }
            if ( w[ a+'Width' ] <= 1024 ) {
                mobile =  true;
            }

            if (mobile && isWhatsNew && homepage) {
                e.preventDefault();
                var $el = $(this);
                var direction = $el.parents('.off-canvas__container').data('off-canvas-direction');
                $('.off-canvas').toggleClass('off-canvas--' + direction);
                document.getElementById('main').scrollIntoView({behavior: "smooth"});
            }
        });

        // var hasntScrolledShop = true;

        // Scroll Caret
        if (document.getElementById('scroll-caret')) {
            $(".scroll-caret-svg")[0].classList.add("scroll-caret-anim");
        
            $("#scroll-caret").click(function(e) {
                let homepage = document.getElementById('main'),
                snapPoint = homepage.getBoundingClientRect().y;
    
                if ('scrollBehavior' in document.documentElement.style) {
                    if (snapPoint > 0) {
                        homepage.scrollIntoView({behavior: "smooth"});
                    }
                } else {
                    let viewHeight = window.innerHeight;

                    if (snapPoint > viewHeight) {
                        $("body, html").animate({
                            scrollTop: snapPoint
                        } /* speed */ );
                    }
                }
            });
        }

        // Desktop accordions
        $('.nav__item__title--first-level').click(function(e) {
            let target = e.target,
                isShop = target.textContent.trim().toUpperCase() === "SHOP",
                secondLevels = Array.from(document.getElementsByClassName('nav__item__title--second-level'));
                homepage = document.getElementById('main'),
                desktop = false,
                w = window, 
                a = 'inner';

            if (!('innerWidth' in window )) {
                    a = 'client';
                    w = document.documentElement || document.body;
            }
            if ( w[ a+'Width' ] > 1024 ) {
                desktop =  true;
            }

            e.preventDefault();
            if (target.parentElement.classList.contains('nav__item--open')) {
                secondLevels.forEach(function(e) {
                    e.parentElement.classList.remove("nav__item--open");
                });
            }
            $(target.parentElement).toggleClass("nav__item--open");
            // if (hasntScrolledShop && isShop && homepage && desktop && window.location.href !== 'https://www.apresjewelry.com/#main') {
            //     let snapPoint = $("#main").offset().top;

            //     if ('scrollBehavior' in document.documentElement.style) {
            //         if (snapPoint > 0) {
            //             homepage.scrollIntoView({behavior: "smooth"});
            //         }
            //     } else {
            //         if (snapPoint > 0) {
            //             $("body, html").animate({
            //                 scrollTop: snapPoint
            //             } /* speed */ );
            //         }
            //     }
            //     hasntScrolledShop = false;
            // }
        });

        $('.nav__item__title--second-level').click( function(e) {
            e.preventDefault();
            $(e.target.parentElement).toggleClass("nav__item--open");
        });
    });
})();